import React from 'react';
import { createPortal } from 'react-dom';
import { observer } from 'mobx-react-lite';

import './style.sass';

import { AppViewModel } from 'app/viewModels';

export const Notifications = observer(() => {
    const notifications = AppViewModel.Instance.notifications.listOfNotifications;

    if (!notifications.length) {
        return null;
    }

    return createPortal(
        <div className="notifications">
            {notifications.map((notification, index) => (
                <div
                    className={`notifications__item ${notification.type}`}
                    key={`${index}__notification`}
                >
                    <span className="p2-medium white-text">{notification.title}</span>
                </div>
            ))}
        </div>,
        document.body,
    ) as React.ReactNode;
});
